/**
 * Auto-generated from dark-roast DAOs (com.axiom.db.models.dao).
 * Shared by all Java backends — do not edit manually.
 * Regenerate with: yarn sync-entities
 */

import { Entity } from '@data-client/rest';
import { AccountRelationship } from '../enums/account-relationship';
import { AvailabilityPreferencesUpdatedByType } from '../enums/availability-preferences-updated-by-type';
import { Badge } from '../enums/badge';
import { BusinessTitle } from '../enums/business-title';
import { ContactMethod } from '../enums/contact-method';
import { CountryCode } from '../enums/country-code';
import { CurrencyCode } from '../enums/currency-code';
import { EducationDegree } from '../enums/education-degree';
import { EmployeeType } from '../enums/employee-type';
import { EmploymentStatus } from '../enums/employment-status';
import { FocusArea } from '../enums/focus-area';
import { JobProfile } from '../enums/job-profile';
import { PracticeAreaEnum } from '../enums/practice-area-enum';
import { ProfileStatus } from '../enums/profile-status';
import { Pronouns } from '../enums/pronouns';
import { YesNo } from '../enums/yes-no';
import { BarredLocationEntity } from './barred-location-entity';
import { CalendarEntity } from './calendar-entity';
import { CandidateIndustryEntity } from './candidate-industry-entity';
import { CandidateLanguageEntity } from './candidate-language-entity';
import { CandidateOpportunityEntity } from './candidate-opportunity-entity';
import { CandidateReputationEntity } from './candidate-reputation-entity';
import { CertificationEntity } from './certification-entity';
import { EducationEntity } from './education-entity';
import { ExperienceEntity } from './experience-entity';
import { HomeOfficeEntity } from './home-office-entity';
import { TagEntity } from './tag-entity';
import { UserEntity } from './user-entity';
export class CandidateEntity extends Entity {
  address1: string | null = null;
  address2: string | null = null;
  addressCity: string | null = null;
  addressCountry: string | null = null;
  addressCountryCode: CountryCode | null = null;
  addressState: string | null = null;
  addressZip: string | null = null;
  alphabeticallySmallestEngagementAccountName: string | null = null;
  alphabeticallySmallestEngagementEndDate: string | null = null;
  alphabeticallySmallestEngagementEndDateStatus: string | null = null;
  availabilityNotes: string | null = null;
  availabilityPreferencesUpdatedAt: string | null = null;
  availabilityPreferencesUpdatedBy: string | null = null;
  availabilityPreferencesUpdatedByUser: UserEntity | null = null;
  averageAdHocHoursWeekly: number | null = null;
  axiomEmployeeType: string | null = null;
  barredLocations: BarredLocationEntity[] = [];
  baseAnnualSalary: number | null = null;
  bonusPercentage: number | null = null;
  bullhornId: string | null = null;
  businessTitle: BusinessTitle | null = null;
  calendar: CalendarEntity | null = null;
  candidateHeader: string | null = null;
  candidateHeaderUpdatedAt: string | null = null;
  candidateOpportunities: CandidateOpportunityEntity[] = [];
  candidateReputation: CandidateReputationEntity | null = null;
  candidateSummary: string | null = null;
  candidateSummaryUpdatedAt: string | null = null;
  certifications: CertificationEntity[] = [];
  communicationAlerts: Record<string, unknown> | null = null;
  compensation: number | null = null;
  compHourly40hr: number | null = null;
  compHourlyPremium: number | null = null;
  counselWorkPreference: string | null = null;
  createdAt: string | null = null;
  currencyType: CurrencyCode | null = null;
  currentAvailabilityUpdatedAt: string | null = null;
  daysDesiredRemote: number | null = null;
  daysRequiredRemote: number | null = null;
  degrees: EducationEntity[] = [];
  desiredCommute: YesNo | null = null;
  desiredEngagementSpecificCompensation: YesNo | null = null;
  desiredHoursUpdatedAt: string | null = null;
  desiredWeeklyMaxHours: number | null = null;
  displayFirstName: string | null = null;
  displayHighHourlyRate: number | null = null;
  displayLastName: string | null = null;
  displayLowHourlyRate: number | null = null;
  displayWeeklyRate: number | null = null;
  employeeType: EmployeeType | null = null;
  employmentStatus: EmploymentStatus | null = null;
  experiences: ExperienceEntity[] = [];
  firstName: string | null = null;
  flaggedAt: string | null = null;
  flaggedBy: string | null = null;
  furthestCandidacyStatus: string | null = null;
  furthestCandidacyStatusUpdatedAt: string | null = null;
  homeOffice: HomeOfficeEntity | null = null;
  homeOfficeId: string | null = null;
  homePhone: string | null = null;
  hourlyCompensation: number | null = null;
  hourlyPrice10hrReserved: number | null = null;
  hourlyPrice10hrReservedLawFirm: number | null = null;
  hourlyPrice20hrReserved: number | null = null;
  hourlyPrice20hrReservedLawFirm: number | null = null;
  hourlyPrice30hrReserved: number | null = null;
  hourlyPrice30hrReservedLawFirm: number | null = null;
  hourlyPrice40hrReserved: number | null = null;
  hourlyPrice40hrReservedLawFirm: number | null = null;
  hourlyPriceVariable: number | null = null;
  hourlyPriceVariableLawFirm: number | null = null;
  hoursPerDay: number | null = null;
  id: string = '';
  industries: CandidateIndustryEntity[] = [];
  integrationId: string | null = null;
  isFlagged: boolean | null = null;
  isOpenToAdHoc: boolean | null = null;
  isOpenToCommute: boolean | null = null;
  isOpenToFullTime: boolean | null = null;
  isOpenToMultipleClients: boolean | null = null;
  isOpenToOtherWork: boolean | null = null;
  isOpenToPartTime: boolean | null = null;
  isOpenToRemote: boolean | null = null;
  isOptInWorkFeedEmail: boolean | null = null;
  isProfileShared: boolean = false;
  isSpotlightedLawyer: boolean | null = null;
  languages: CandidateLanguageEntity[] = [];
  lastName: string | null = null;
  lastUpdatedBy: string | null = null;
  latestEngagementAccountName: string | null = null;
  latestEngagementEndDate: string | null = null;
  lawSchool: string | null = null;
  lawSchoolId: string | null = null;
  loginEmail: string | null = null;
  maxHours: number | null = null;
  middleName: string | null = null;
  minWeeklyHoursPerPosition: number | null = null;
  mobilePhone: string | null = null;
  noticePeriod: string | null = null;
  openToLargeProjects: boolean = false;
  openToLawFirms: boolean = false;
  openToPermanentPlacement: boolean = false;
  openToSecondment: boolean = false;
  openToVariableHourlyProjects: boolean = false;
  oppAlertsMessageDismissed: boolean = false;
  ownerUser: UserEntity | null = null;
  ownerUserId: string | null = null;
  partTimeHoursFri: number | null = null;
  partTimeHoursMon: number | null = null;
  partTimeHoursThu: number | null = null;
  partTimeHoursTue: number | null = null;
  partTimeHoursWed: number | null = null;
  personalEmail: string | null = null;
  practiceStartYear: number | null = null;
  preferredContactMethod: ContactMethod | null = null;
  previousProfileStatus: string | null = null;
  pricingCurrency: string | null = null;
  primaryFocusArea: FocusArea | null = null;
  primaryPracticeArea: PracticeAreaEnum | null = null;
  profileImageKey: string | null = null;
  profileImageName: string | null = null;
  profileStatus: ProfileStatus | null = null;
  profileStatusLastUpdatedBy: string | null = null;
  profileStatusLastUpdatedByUser: UserEntity | null = null;
  profileStatusUpdatedAt: string | null = null;
  profileVisibilityPreferencesReviewedBy: string | null = null;
  profileVisibilityReviewedAt: string | null = null;
  programsPreferencesReviewedAt: string | null = null;
  programsPreferencesReviewedBy: string | null = null;
  pronouns: Pronouns | null = null;
  publicRefId: number = 0;
  resume: string | null = null;
  rewardsPlan: string | null = null;
  searchableByClient: boolean | null = null;
  settings: Record<string, unknown> | null = null;
  showReputation: boolean | null = null;
  soonestEngagementAccountName: string | null = null;
  soonestEngagementEndDate: string | null = null;
  soonestEngagementEndDateStatus: string | null = null;
  suggestPhotoDismissedAt: string | null = null;
  tags: TagEntity[] = [];
  terminationDate: string | null = null;
  terminationReason: string | null = null;
  timezone: string | null = null;
  updatedAt: string | null = null;
  user: UserEntity | null = null;
  weeklyAvailability: number | null = null;
  weeklyPriceFullTime: number | null = null;
  weeklyPriceFullTimeLawFirm: number | null = null;
  workEmail: string | null = null;
  workStylePreferencesReviewedAt: string | null = null;
  workStylePreferencesReviewedBy: string | null = null;
  accountRelationship?: AccountRelationship | null = null;
  activeWorkEmail?: string | null = null;
  availabilityPreferencesUpdatedByType?: AvailabilityPreferencesUpdatedByType | null = null;
  badges?: Badge[] | null = null;
  calculatedDesiredWeeklyHours?: number | null = null;
  calculatedDisplayName?: string | null = null;
  calculatedFirstName?: string | null = null;
  calculatedLastName?: string | null = null;
  candidateId?: string | null = null;
  canDisplayReputationData?: boolean | null = null;
  daysSinceAvailabilityUpdate?: number | null = null;
  daysSinceStatusChange?: number | null = null;
  degree?: EducationDegree | null = null;
  email?: string | null = null;
  hasRate?: boolean | null = null;
  hasRateForExternalView?: boolean | null = null;
  institution?: string | null = null;
  isAccessibleToWorkFeed?: boolean | null = null;
  isAvailableToConsult?: boolean | null = null;
  isCrossFulfilled?: boolean | null = null;
  isInterviewableFromALT?: boolean | null = null;
  isInterviewAvailabilityOutdated?: boolean | null = null;
  isPrimary?: boolean | null = null;
  isPriorityTalent?: boolean | null = null;
  jobProfile?: JobProfile | null = null;
  maxDailyHours?: number | null = null;
  preferredWeeklyHoursMaximum?: number | null = null;
  restricted?: boolean | null = null;
  rolloffDate?: string | null = null;
  yearAwarded?: number | null = null;
  yearsOfExperience?: number | null = null;
  static override key = 'Candidate';
  static override get schema() {
    return {
      availabilityPreferencesUpdatedByUser: UserEntity,
      barredLocations: [BarredLocationEntity],
      calendar: CalendarEntity,
      candidateOpportunities: [CandidateOpportunityEntity],
      candidateReputation: CandidateReputationEntity,
      certifications: [CertificationEntity],
      degrees: [EducationEntity],
      experiences: [ExperienceEntity],
      homeOffice: HomeOfficeEntity,
      languages: [CandidateLanguageEntity],
      ownerUser: UserEntity,
      profileStatusLastUpdatedByUser: UserEntity,
      tags: [TagEntity],
      user: UserEntity,
    };
  }
  static override toJSON() {
    return { name: this.name, schema: {}, key: this.key };
  }
  static override process(input: unknown): unknown {
    if (
      input !== null &&
      typeof input === 'object' &&
      'Candidate' in input
    ) {
      const { Candidate: wrapped, ...rest } = input as {
        Candidate: object;
      } & object;
      return { ...(wrapped as object), ...rest };
    }
    return input;
  }
}